import Vue from 'vue';
import Vuex, {ActionContext} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Achat, User, Client, Transporteur, Fournisseur} from '@/models';
import {AchatService} from "@/xhttp";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';
import {BoisType, LongueursAchat} from '@/models';

Vue.use(Vuex);

export class AchatFilter {

	date: string = '';
	fournisseur: Fournisseur[] = [];
	numero: string = '';
	address: string = '';

	public clear(): void {
		this.date = '';
		this.fournisseur = [];
		this.numero = '';
		this.address = '';
	}

	public toString(): string {
		return JSON.stringify({
			fournisseur    : this.fournisseur.map(t => t.id),
			numero	: this.numero,
			address	: this.address,
		});

	}
}

export class AchatFilterList {

	BoisType: BoisType = null;
	LongueurAchat: LongueursAchat = null;
	Coupe_fini: boolean = true;

	public clear(): void {
		this.BoisType = null;
		this.LongueurAchat = null;
		this.Coupe_fini = true;
	}
}

export class AchatFilterListEnCours {

	BoisSurPied: boolean = false;

	public clear(): void {
		this.BoisSurPied = false;
	}
}

class AchatState extends PaginatorFilterState<AchatFilter> {
	achat: Achat = null;
	achats: ResultType<Achat> = null;
	public constructor() {
		super(new AchatFilter(), 'achats', 'achat', 'id', AscDesc.DESC, 100)
	}
}

class AchatStore {

	@XHTTPService(() => Achat)
	private achatService: AchatService;

	public state: AchatState = new AchatState();

	public mutations = {
		...PaginatorMutation(() => storeAchat, 'achats', 'achat'),
	};

	public actions = {
		...StandardAction<Achat, AchatState>(() => Achat, 'achat'),
		...PaginatorActionWithFilters<Achat, AchatState>(() => Achat, 'achats', 'achat'),

		putMarkPaid(context: ActionContext<AchatState, any>, achat: Achat) {
			return instance.achatService.putMarkPaid(achat);
		},

		putFinCoupe(context: ActionContext<AchatState, any>, achat: Achat) {
			return instance.achatService.putFinCoupe(achat);
		},
	};

}

const instance = new AchatStore();
const storeAchat = new Vuex.Store(instance);
store.registerModule('achat', storeAchat);
export default storeAchat;
